import { Subjects } from "src/api/product";
import { create } from "zustand";
// 기본값 상수
export const DEFAULT_HOME_TYPE = "teacher";
export const DEFAULT_TEACHER_SUBJECT = Subjects.EN;
export const DEFAULT_STUDENT_SUBJECT = "ALL";
export const useHomeSwitchStore = create()((set)=>({
        homeType: DEFAULT_HOME_TYPE,
        subject: DEFAULT_TEACHER_SUBJECT,
        homeId: "",
        initializedWithLogin: null,
        setHomeId: (homeId)=>set({
                homeId
            }),
        setHomeType: (type)=>set({
                homeType: type
            }),
        setSubject: (subject)=>set({
                subject
            }),
        setHomeState: (type, subject, initializedWithLogin)=>set({
                homeType: type,
                subject,
                ...initializedWithLogin !== undefined && {
                    initializedWithLogin
                }
            }),
        reset: ()=>set({
                homeType: DEFAULT_HOME_TYPE,
                subject: DEFAULT_TEACHER_SUBJECT,
                initializedWithLogin: null
            })
    }));
